import { render, staticRenderFns } from "./PriceInfo.vue?vue&type=template&id=bb72511a"
import script from "./PriceInfo.vue?vue&type=script&lang=js"
export * from "./PriceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports